export const nodeList = {"flow":[
  {
    text: '开始',
    type: 'start',
    class: 'node-start'
  },
  {
    text: '任务',
    type: 'rect',
    class: 'node-rect'
   },

  {
    type: 'jugement',
    text: '判断',
    class:'node-jugement'
  },
  {
    type: 'task',
    text: '系统处理',
    class:'node-task'
  },
  {
    type: 'subflow',
    text: '子流程',
    class:'node-subflow'
  },
  {
    type: 'end',
    text: '结束',
    class: 'node-end'
  },
],
"panel":[
  {
    type: 'jugement',
    text: '判断',
    class:'node-jugement'
  },
  {
    type: 'subflow',
    text: '子流程',
    class:'node-subflow'
  },
  {
    type: 'subflow',
    text: '子流程',
    class:'node-subflow'
  }
]};


